<!-- TODO:start -->
<!-- 
En fait, il faut le prime-accordion comme parent pour utiliser le p-accordionTab
  => Il faut voir si ce fix n'a pas d'effet de bord
-->
<!-- TODO:end -->
<iu-prime-accordion>
  <p-accordionTab
    [attr.data-cy-accordion-name]="label"
    [contentStyleClass]="'blade-grid'"
    [ngClass]="[isMandatory ? 'mandatory' : '']"
    [ngStyle]="{ display: displayCss }"
    [selected]="selected"
    [style.--blade-nb-cols]="contentNbCol">
    <ng-template iuDynamicContainer />
    <ng-template pTemplate="icon" />
    <ng-template pTemplate="header">
      <span class="prime-accordion-header">
        <span class="prime-accordion-header-label">
          {{ label }}
        </span>
        <span class="prime-accordion-header-line" [attr.aria-hidden]="true"></span>
        <span class="prime-accordion-header-icon" [attr.aria-hidden]="true"></span>
      </span>
    </ng-template>
  </p-accordionTab>
</iu-prime-accordion>
